import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Icon imports
import icon from 'leaflet/dist/images/marker-icon.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import shadow from 'leaflet/dist/images/marker-shadow.png';

// Safe patch to fix missing icon warnings (TypeScript compatible)
if (L.Icon.Default.prototype && '_getIconUrl' in L.Icon.Default.prototype) {
  // The Leaflet typings do not expose this property, but it's safe to delete
  // it to avoid missing icon warnings.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  delete (L.Icon.Default.prototype as any)._getIconUrl;
}
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: icon,
  shadowUrl: shadow,
});

interface InteractiveMapProps {
  position: [number, number];
  popupText?: string;
  zoom?: number;
}

const InteractiveMap: React.FC<InteractiveMapProps> = ({
  position,
  popupText = 'Our Location',
  zoom = 13,
}) => {
  return (
    <div className="w-full h-full rounded overflow-hidden border border-[#3a3a3a]">
      <MapContainer
        center={position}
        zoom={zoom}
        scrollWheelZoom={true} // Activar zoom con scroll del mouse
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={position}>
          <Popup>{popupText}</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default InteractiveMap;
